import { useState } from 'react';
import { toast } from 'sonner';
import { Mountain, Loader2 } from 'lucide-react';
import { useAltitude, heightFor, fmtAlt } from '../lib/altitude';

const SRC_ICON = { gnss: '🛰️', gps: '📡', dem: '🗺️', manual: '✍️' };

// live height above sea level (map chip)
export function AltChip({ t }) {
  const a = useAltitude();
  return (
    <div className="alt-chip" data-testid="alt-chip" title={t.altHint}>
      <Mountain size={13} /> <b data-testid="alt-chip-value">{fmtAlt(a.alt)}</b> <small>{t.altAsl}</small>
      {a.src && <small data-testid="alt-chip-src">{SRC_ICON[a.src]} {t['altSrc_' + a.src]}{a.acc ? ` ±${Math.round(a.acc)} m` : ''}</small>}
      {a.dem != null && a.src !== 'dem' && <small data-testid="alt-chip-dem">· {t.altSrc_dem} {fmtAlt(a.dem)}</small>}
    </div>
  );
}

// object sheet: height of a fitting (take over + manual correction)
export function ElevField({ t, obj, patch }) {
  const [busy, setBusy] = useState(false);
  useAltitude();
  const e = obj.elev;
  const take = async () => {
    setBusy(true);
    try { const r = await heightFor(obj.lat, obj.lon); patch({ elev: { ...r, at: Date.now() } }); toast.success(`${t.altLbl}: ${fmtAlt(r.v)}`); } catch { toast.error(t.altErr); }
    setBusy(false);
  };
  return (
    <div className="elev-field" data-testid="object-elev">
      <label><Mountain size={14} /> {t.altLbl}
        <input type="number" step="0.01" inputMode="decimal" data-testid="object-elev-input" value={e?.v ?? ''} placeholder="m"
          onChange={(ev) => patch({ elev: ev.target.value === '' ? null : { v: +ev.target.value, src: 'manual', at: Date.now() } })} />
      </label>
      {e?.src && <small data-testid="object-elev-src">{SRC_ICON[e.src]} {t['altSrc_' + e.src]}{e.acc ? ` ±${(+e.acc).toFixed(2)} m` : ''}</small>}
      <button className="btn btn-outline btn-sm" data-testid="object-elev-take-btn" disabled={busy} onClick={take}>{busy ? <Loader2 size={13} className="spin" /> : <Mountain size={13} />} {t.altTake}</button>
    </div>
  );
}
